"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _PasswordRules = _interopRequireDefault(require("./PasswordRules"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class PasswordStrength extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      meterWidth: null,
      meterTitle: null,
      meterClass: null,
      password: null,
      rules: {
        hasNumber: false,
        hasLetter: false,
        hasUppercase: false,
        isValidLength: false,
        noSpecialChar: true
      }
    });
    _defineProperty(this, "handlePasswordChange", event => {
      const {
        value
      } = event.target;
      const lengthRegExp = new RegExp('^.{' + this.props.rules.minLength + ',}$');
      this.setState({
        rules: {
          hasNumber: value.match(/\d/),
          hasLetter: value.match(/[a-z]/),
          hasUppercase: value.match(/[A-Z]/),
          isValidLength: value.match(lengthRegExp),
          noSpecialChar: !value.match(/[ /"]/)
        }
      }, function () {
        this.setMeterAttributes();
      });
      this.props.onInputChange(event);
    });
    _defineProperty(this, "setMeterAttributes", () => {
      const meterWidth = this.getMeterWidth();
      this.props.onPasswordValidate(meterWidth === 100);
      this.setState({
        meterWidth: meterWidth,
        meterTitle: 100 === meterWidth ? "Valid Password" : "Invalid Password",
        meterClass: meterWidth > 25 ? meterWidth > 75 ? 'bg-success' : 'bg-warning' : 'bg-danger'
      });
    });
    _defineProperty(this, "getMeterWidth", () => {
      const {
        rules
      } = this.state;
      let property_count = 0,
        valid_property_count = 0,
        property;
      for (property in rules) {
        if (Object.prototype.hasOwnProperty.call(rules, property)) {
          property_count = property_count + 1;
          if (rules[property]) {
            valid_property_count = valid_property_count + 1;
          }
        }
      }
      return valid_property_count / property_count * 100;
    });
    _defineProperty(this, "getSingleRuleStatus", status => status ? 'valid' : 'invalid');
  }
  render() {
    const {
      children,
      rules
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", null, _react.default.cloneElement(children, {
      onChange: this.handlePasswordChange
    }), rules && /*#__PURE__*/_react.default.createElement(_PasswordRules.default, {
      isValidLength: this.getSingleRuleStatus(this.state.rules.isValidLength),
      hasNumber: this.getSingleRuleStatus(this.state.rules.hasNumber),
      hasLetter: this.getSingleRuleStatus(this.state.rules.hasLetter),
      hasUppercase: this.getSingleRuleStatus(this.state.rules.hasUppercase),
      noSpecialChar: this.getSingleRuleStatus(this.state.rules.noSpecialChar),
      rules: rules
    }));
  }
}
exports.default = PasswordStrength;
module.exports = exports.default;